import { Col, Row, Typography } from 'antd'
import Container from 'components/Container'
import styled, { css } from 'styled-components'
import { color, fontSize, margin, padding, screen } from 'theme/mixins'

const Wrapper = styled(Container)<{ $short?: boolean }>`
	padding: ${padding('sm')} ${padding('lg')};
	${({ $short }) =>
		$short &&
		css`
			padding-left: 0;
		`}
	font-size: ${fontSize('sm')};
`

const LayoutRow = styled(Row)`
	.ant-row {
		${screen.gte.sm`
			border-bottom: 1px solid ${color(['gray', '100'])};
		`}
		padding: ${padding('xs')} 0;
		&:first-child {
			border-bottom: 1px solid ${color(['gray', '100'])};
			border-top: 1px solid ${color(['gray', '100'])};
			align-items: center;
		}
	}
`

const CopyIconContainer = styled(Container)`
	display: inline-block;
	color: ${color('primary')};
	margin-left: ${margin('xxs')};
`

const Valuation = styled(Typography.Text)`
	font-size: ${fontSize('xs')};
`

const RightCol = styled(Col)`
	/* .ant-typography {
		line-height: 40px;
	} */
`

export default { Wrapper, RightCol, LayoutRow, CopyIconContainer, Valuation }
